module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('signup-type', {
    attrs: {
      "chosenType": _vm.chosenType
    },
    on: {
      "typeChanged": _vm.updateSignupComponentType
    }
  }), _vm._v(" "), _c(_vm.signupComponentType, {
    tag: "component"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-a1b9e48e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1b9e48e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/SignupStart.vue
// module id = 2595
// module chunks = 0